module.exports = __webpack_public_path__ + "media/images/home/chuva_agora-6db03ad5fe9dc3cc46a5f053b49f79ca.png";